import { render } from "./product-usps.vue?vue&type=template&id=f48c4298"
import script from "./product-usps.vue?vue&type=script&lang=js"
export * from "./product-usps.vue?vue&type=script&lang=js"

import "./product-usps.vue?vue&type=style&index=0&id=f48c4298&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__